import { Component, OnInit } from '@angular/core';
import { BaseComponent, ErrorsUtil, MessageBoxComponent, WaitComponent } from '@sircon/sircon-ui-framework';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpService } from 'src/services/help.service';
import { CarrierInformation } from 'src/app/core/models/carrier-information.model';
import { NgClass, NgIf } from '@angular/common';
import { BrandInformationComponent } from '../brand-information/brand-information.component';

@Component({
    selector: 'app-sso-producer-not-found',
    templateUrl: './sso-producer-not-found.component.html',
    styleUrls: ['./sso-producer-not-found.component.less'],
    imports: [NgIf, WaitComponent, NgClass, MessageBoxComponent, BrandInformationComponent]
})
export class SsoProducerNotFoundComponent extends BaseComponent implements OnInit {
    errors = ErrorsUtil.create();
    loadingBrand = false;
    brandKey: string;
    entityType: string;
    carrierInformation: CarrierInformation;

    constructor(
        private helpService: HelpService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.brandKey = this.route.snapshot.queryParams.brandKey;
        this.entityType = this.route.snapshot.queryParams.entityType;
        this.loadingBrand = !!this.brandKey;
    }

    brandedWalkupHelpUrl() {
        return this.helpService.getInsuranceHelpPath();
    }

    loadingBrandEvent(loading: boolean): void {
        this.loadingBrand = loading;
    }

    loadingBrandErrorEvent(): void {
        this.errors.serviceUnavailable = true;
    }

    carrierInformationEvent(carrierInformation: CarrierInformation): void {
        this.carrierInformation = carrierInformation;
    }

    goToLogin(): void {
        if (this.entityType === 'Agency') {
            this.router.navigate(['/agencyLogin'], { queryParams: {  brandKey: this.brandKey  }});
        } else {
            this.router.navigate(['/login'], { queryParams: {  brandKey: this.brandKey  }});
        }
    }
}
